import { cva } from 'class-variance-authority';

export const splitTableVariants = cva(
  'box-border w-full min-w-0 overflow-hidden rounded-lg border border-border'
);

export const splitTableRowVariants = cva(
  'grid w-full min-w-0 items-stretch grid-cols-[11rem_minmax(0,1fr)_8.125rem_10rem] border-b border-border bg-card last:border-b-0',
  {
    variants: {
      tone: {
        default: '',
        inBetween: 'bg-gray-10',
      },
    },
    defaultVariants: {
      tone: 'default',
    },
  }
);

export const splitTableHeaderRowVariants = cva(
  'grid w-full min-w-0 items-stretch grid-cols-[11rem_minmax(0,1fr)_8.125rem_10rem] border-b border-border bg-card'
);

export const splitTableCellVariants = cva(
  'flex h-full min-h-[4.5625rem] items-center py-5 pr-4 pl-6'
);

export const splitTableHeaderCellVariants = cva(
  'flex h-full min-h-[2.25rem] items-center py-2 pr-4 pl-6'
);

export const splitTableHeaderLabelVariants = cva(
  'text-[12px] font-semibold not-italic leading-snug tracking-wider uppercase text-[#5c6166]'
);

export const splitTableCheckpointCellVariants = cva('', {
  variants: {
    kind: {
      checkpoint: '',
      inBetween: '',
    },
  },
  defaultVariants: {
    kind: 'checkpoint',
  },
});

export const splitTableCheckpointLabelVariants = cva('font-semibold leading-snug', {
  variants: {
    kind: {
      checkpoint: 'text-base text-foreground',
      inBetween: 'pl-6 text-[13px] text-gray-600',
    },
  },
  defaultVariants: {
    kind: 'checkpoint',
  },
});

export const splitTableTimeLabelVariants = cva('text-base font-normal leading-snug', {
  variants: {
    emphasis: {
      default: 'text-foreground',
      estimated: 'italic text-gray-300',
    },
  },
  defaultVariants: {
    emphasis: 'default',
  },
});
